import { makeStyles } from "@mui/styles";
import { headerFontFamily } from "styles/theme/mui";

export const useStyles = makeStyles(() => ({
  mainHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%",
  },
  mainHeaderEndIcon: {
    justifyContent: "flex-end",
    direction: "ltr",
    padding: "0px 10px",
  },
  backButton: {
    padding: "4px !important",
  },
  backIcon: {
    color: "#253858",
    fontSize: "20px !important",
  },
  textHeader: {
    color: "#253858",
    fontFamily: headerFontFamily,
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "140%",
    letterSpacing: 0,
  },
  parentText: {
    color: "#8B95A5",
    fontFamily: headerFontFamily,
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "140%",
  },
  activeText: {
    color: "#253858",
    fontFamily: headerFontFamily,
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "140%",
  },
  separator: {
    color: "#8B95A5",
    fontFamily: headerFontFamily,
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "140%",
  },
}));
